
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[language]",
      function () {
        return require("private-next-pages/login/[language].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/[language]"])
      });
    }
  